import { BackendEvent } from '../../models/BackendEvents';
import TenderAssistantStreamingViewer from '../../ui/markdown-wrapper/hooks/useActions/actions/data/custom/dcs-tender-assistant/TenderAssistantStreamingViewer';

const StreamingViewer = ({
    type,
    chatId,
    events,
    onComplete
}: {
    type: string;
    chatId: string;
    events: BackendEvent[];
    onComplete: () => void;
}) => {
    // Route to specific streaming implementation based on type
    switch (type) {
        case 'tender-assistant':
            return <TenderAssistantStreamingViewer
                chatId={chatId}
                events={events}
                onComplete={onComplete}
            />;

        // Future streaming tools can be added here:

        default:
            return (
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    <h3>Unknown streaming type: {type}</h3>
                    <p>This streaming viewer is not yet implemented.</p>
                </div>
            );
    }
};

export default StreamingViewer;